import ApiUtils from "../ApiUtils";

export default class ApiClassService {

    // Dashboard
    async getDashboardUpcomingClasses() {
        return await ApiUtils.callApi('dashboard/classes/upcoming','get',[],false,false);
    }

    // Class add & edit
    async addClass(data) {
        return await ApiUtils.callApi('class/add','post',data);
    }

    async findClasses(data,page) {
        return await ApiUtils.callApi(`class/find?page=${page}`,'post',data);
    }

    async getClassForEdit(classId) {
        return await ApiUtils.callApi(`class/edit/${classId}`,'get');
    }

    async updateClass(data) {
        return await ApiUtils.callApi('class/edit','post',data);
    }

    async generateNewForm(data){
        return await ApiUtils.callApi(`class/create/spreadsheet`,'post',data);
    }

    async uploadClassSpreadsheet(data){
        return await ApiUtils.callApi(`class/upload/spreadsheet`,'post',data);
    }

    // Class details
    async getClassChangesDetails(classId){
        return await ApiUtils.callApi(`class/changes/${classId}`,'get');
    }

    // Upload webcast material
    // General Files
    async getGeneralFiles(topicId){
        return await ApiUtils.callApi(`class/materials/general-files/${topicId}`,'get');
    }

    async deleteGeneralFile(fileId){
        return await ApiUtils.callApi(`class/materials/delete-general-files/${fileId}`,'delete');
    }

    async uploadGeneralFile(data){
        return await ApiUtils.callApi(`class/materials/upload/general-files`,'post',data);
    }

    // Company Handouts
    async getCompanyHandouts(topicId,companyId){
        return await ApiUtils.callApi(`class/materials/company-handout-files/${topicId}${companyId ? '/'+companyId : ''}`,'get');
    }

    async deleteCompanyHandouts(fileId){
        return await ApiUtils.callApi(`class/materials/delete-company-handout/${fileId}`,'delete');
    }

    async uploadCompanyHandouts(data){
        return await ApiUtils.callApi(`class/materials/company-handout-files`,'post',data);
    }

    // Recorded Webcast Materials
    async getRecordedWebcastMaterial(topicId,companyId){
        return await ApiUtils.callApi(`class/materials/recorded-webcast/${topicId}${companyId ? '/'+companyId : ''}`,'get');
    }

    async deleteRecordedWebcastMaterial(fileId){
        return await ApiUtils.callApi(`class/materials/delete-recorded-webcast/${fileId}`,'delete');
    }

    async uploadRecordedWebcastMaterial(data){
        return await ApiUtils.callApi(`class/materials/recorded-webcast`,'post',data);
    }

    // Webcast Video Links
    async getWebcastVideos(topicId,companyId){
        return await ApiUtils.callApi(`class/materials/video-link/${topicId}${companyId ? '/'+companyId : ''}`,'get');
    }

    async deleteWebcastVideo(videoId){
        return await ApiUtils.callApi(`class/materials/delete-video-link/${videoId}`,'delete');
    }

    async addWebcastVideo(data){
        return await ApiUtils.callApi(`class/materials/add-video-link`,'post',data);
    }

    //enrollment report
    async getEnrollmentReport(classId){
        return await ApiUtils.callApi(`class/report/enrollment/${classId}`,'get');
    }

    //modify class attandence
    async getClassAttendanceDetails(classId){
        return await ApiUtils.callApi(`class/attendance/${classId}`,'get');
    }

    async updateClassAttendanceDetails(data){
        return await ApiUtils.callApi(`class/attendance`,'post', data);
    }

    //Class roaster apis
    async addStudentToClassRoaster(data){
        return await ApiUtils.callApi(`class/roster/student/add`,'post', data);
    }

    async removeStudentFromClassRoaster(data){
        return await ApiUtils.callApi(`class/roster/student/remove`,'post', data);
    }

    //Class status email send
    async statusEmailSummary(data){
        return await ApiUtils.callApi(`class/status/email/summary`,'post',data)
    }

    async sendStatusEmail(data){
        return await ApiUtils.callApi(`class/status/email/send`,'post',data)
    }
}
